import {combineReducers} from 'redux';

import bulkCancelInvoice, {
    type BulkCancelState,
} from 'web-app/react/plans/debt-report/billing-activity-overview/confirm-bulk-cancel-invoice/reducer';
import {type BatchInvoicing} from 'web-app/react/plans/debt-report/batch-invoice/reducer';

import volumeSettings from './volume-settings/reducer';
import discountSettings from './discount-settings/reducer';
import planSettings from './plans-settings/reducer';
import managePlan from './manage-plan/reducer';
import {type ManagePlan} from './manage-plan/types/reducer-types';
import revenueReport, {type RevenueReportState} from './revenue-report/reducer';
import debtReportV2, {type DebtReportState} from './debt-report-v2/reducer';
import batchInvoice from './debt-report/batch-invoice/reducer';
import billingActivityOverview from './debt-report/billing-activity-overview/reducer';
import occupancyPlanner from './occupancy-planner/reducer';
import publicFundingReport from './public-funding-report/reducer';
import manageAgeGroups from './manage-age-groups/reducer';
import revenueDetails from './revenue-details/reducer';

interface PlansReducers {
    volumeSettings: any;
    discountSettings: any;
    planSettings: any;
    managePlan: ManagePlan;
    revenueReport: RevenueReportState;
    debtReportV2: DebtReportState;
    batchInvoice: BatchInvoicing;
    occupancyPlanner: any;
    publicFundingReport: any;
    manageAgeGroups: any;
    billingActivityOverview: any;
    revenueDetails: any;
    bulkCancelInvoice: BulkCancelState;
}

const plans = combineReducers<PlansReducers>({
    volumeSettings,
    discountSettings,
    planSettings,
    managePlan,
    revenueReport,
    debtReportV2,
    batchInvoice,
    occupancyPlanner,
    publicFundingReport,
    manageAgeGroups,
    billingActivityOverview,
    revenueDetails,
    bulkCancelInvoice,
});

export default plans;
